<mpro-dropdown
  [horizontal]="horizontal"
  title="Age group"
  [inputValue]="getInputValue()"
  (openDropdownAction)="onDropdownOpened()"
>
  <div *ngIf="!addNew" class="dropdown-content-wrapper">
    <div class="sections-wrapper">
      <div class="section-wrapper">
        <div class="section">
          <div class="title-label user-title-label" *ngIf="userGroups.length">
            Your groups
          </div>
          <ng-container *ngIf="userGroups.length">
            <mpro-dropdown-item
              class="inverse-hover"
              *ngFor="let g of userGroups"
              [actions]="true"
              [leftText]="g.displayValue()"
              [middleText]="g.name"
              (itemClicked)="onGroupClicked(g)"
              (editClicked)="onEditClicked(g)"
              [selected]="isGroupSelected(g)"
              (deleteClicked)="onDeleteClicked(g)"
              stopClickPropagation
            >
            </mpro-dropdown-item>
            <hr />
          </ng-container>
          <div class="title-label">Standard Groups</div>
          <mpro-dropdown-item
            class="system-group"
            *ngFor="let g of systemGroups"
            [leftText]="g.displayValue()"
            [middleText]="g.name"
            [disabled]="g.disabled || !!g.authDisabled"
            [showLock]="!!g.authDisabled"
            (itemClicked)="onGroupClicked(g)"
            [selected]="isGroupSelected(g)"
          ></mpro-dropdown-item>
        </div>
        <div
          *ngIf="!hideNew && (authService.permissions$ | async) as plan"
          class="new-btn-wrapper"
        >
          <button
            blockOnClickEvent
            [condition]="plan?.isFreemium || false"
            [requestCategory]="'New age group'"
            [callback]="authService.openFreemiumRequestModal"
            (click.checkBlockEvent)="setAddNew(true)"
            class="mpro-btn mpro-btn-primary new-btn"
            stopClickPropagation
          >
            <fa-icon [icon]="faPlus"></fa-icon>
            <span>New Age Group</span>
            <fa-icon
              *ngIf="!authService.isLoggedIn() || plan.isFreemium"
              [icon]="faLock"
            ></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <mpro-dialog-box
    class="mpro-box"
    *ngIf="addNew"
    (save)="onSave($event)"
    (preview)="onPreview($event)"
    (cancel)="onCancel()"
    title="Create Age Group"
    inputTitle="Name"
    subtitle="Drag the slider or enter your desired age range in the fields below."
    [rangeFilter]="inEditAgeGroup"
    [min]="0"
    [max]="max"
    [customSteps]="customSteps"
    [dynamicRange]="true"
  >
  </mpro-dialog-box>
</mpro-dropdown>

<mpro-delete-modal
  [(open)]="isDeleteModalOpen"
  [resourceName]="ageGroupForDeletion?.name || ''"
  (onDelete)="onDelete()"
>
</mpro-delete-modal>
